import React from 'react'
import clsx from 'clsx'

/* blocks */
import Link from '@/atoms/Link/Link'
import Button from '@/atoms/Button/Button'

/* dataLayer */
import { dataLayerCtaClickEvent } from '@/utils/functions/dataLayerEvents'

/* assets */
import { ReactComponent as ArrowLeft } from 'public/assets/icons/arrow-right.svg'
import { ReactComponent as CheckOutlinedIcon } from 'public/assets/icons/check_outlined.svg'

interface Props {
  title: string
  description?: string
  list: StrapiGeneralList
  ctaTitle: string
  onCtaClick?: () => void
  ctaLink?: string
  sectionName: string
}

const GettingStarted = ({
  title,
  description,
  list,
  ctaTitle,
  onCtaClick,
  ctaLink,
  sectionName
}: Props) => {
  const isCtaLinkInternal = ctaLink ? /^[/#?]/.test(ctaLink) : false

  const handleCtaClick = () => {
    dataLayerCtaClickEvent({ ctaName: ctaTitle, sectionName })
  }

  return (
    <section
      className={clsx(
        'bg-yellow-10 text-center |  py-20 px-5 sm:px-10 lg:px-6'
      )}
    >
      <div className="max-desktop-width  |  mx-auto">
        <h2
          className="h2 font-medium text-center  |  mb-10 mx-auto"
          style={{ maxWidth: 784 }}
        >
          {title}
        </h2>
        {description && (
          <h3 className="text-paragraph-2 text-gray-70 |  mb-10">
            {description}
          </h3>
        )}

        {onCtaClick && (
          <Button
            className="mb-10 mx-auto"
            icon={<ArrowLeft />}
            size="large"
            onClick={() => {
              handleCtaClick()
              onCtaClick()
            }}
          >
            {ctaTitle}
          </Button>
        )}

        {ctaLink && (
          <Link
            href={ctaLink}
            target={isCtaLinkInternal ? '_self' : '_blank'}
            rel={isCtaLinkInternal ? 'noreferrer' : ''}
          >
            <Button
              className="mb-10 mx-auto"
              icon={<ArrowLeft />}
              size="large"
              onClick={handleCtaClick}
            >
              {ctaTitle}
            </Button>
          </Link>
        )}

        <ul
          className={clsx(
            'flex flex-wrap lg:items-center flex-col sm:flex-row justify-center  | sm:space-x-12'
          )}
        >
          {list.map(item => (
            <li
              key={item.id}
              className="text-paragraph-3 text-left  |  flex items-center  |  mb-4"
            >
              <CheckOutlinedIcon className="text-yellow-50 flex-shrink-0  |  mr-4" />
              {item.Item}
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

export default GettingStarted
